<div
  class="notification-wrapper position-relative"
  (click)="togglePanel($event)"
>
  <app-icon color="#fff" icon="NOTIFICATIONS"></app-icon>
  @if (hasNew) {
  <span
    class="notification-badge translate-middle p-1 bg-danger border border-light rounded-circle"
    style="z-index: 1"
  >
    <span class="visually-hidden">New alerts</span>
  </span>
  } @if (showPanel) {
  <div class="notification-panel">
    <div class="notification-header">
      Notifications
      <span class="close-btn" (click)="togglePanel($event)">&times;</span>
    </div>
    <div class="notification-body">
      @for (notification of notifications; track $index) {
      <div (click)="onClickNotification(notification)" class="notification-item">
        <div class="title">{{ notification.message }}</div>
        <div class="time">{{ notification.createdDate | date : "yyyy-MM-dd HH:mm" }}</div>
      </div>
      }
    </div>
  </div>
  }
</div>
